export default __webpack_public_path__ + "static/media/logo-crol.7bfd4602.svg";